/* ============================================================
   ปุ่ม "จัดการคอลัมน์" — เลือกว่าจะแสดงคอลัมน์ไหนในตาราง
   จำค่าไว้ใน cookie ของเครื่องนั้น (ดู utils/table-cookie.js)

   ใช้ซ้ำได้กับตารางอื่น เพียงส่ง cookieName ที่ไม่ซ้ำกันเข้ามา

   props
     columns     : อาเรย์คอลัมน์ของ antd (ต้องมี key และ title)
     hidden      : อาเรย์คีย์ที่ซ่อนอยู่ตอนนี้
     onChange    : (hiddenKeys) => void
     lockedKeys  : คีย์ที่ห้ามซ่อน เช่น คอลัมน์ปุ่มตัวเลือก
============================================================ */
import React, { useMemo, useState } from "react";
import { Button, Popover, Checkbox, Space, Typography, Divider } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function ColumnSettings({
  columns = [],
  hidden = [],
  onChange,
  lockedKeys = [],
  buttonText = "จัดการคอลัมน์",
}) {
  const [open, setOpen] = useState(false);

  /* เอาเฉพาะคอลัมน์ที่มีหัวข้อจริง (คอลัมน์ drag/ช่องว่างไม่ต้องเอามาให้เลือก) */
  const options = useMemo(
    () =>
      columns
        .filter((c) => c?.key && c?.title && typeof c.title === "string")
        .map((c) => ({
          key: c.key,
          title: c.title,
          locked: lockedKeys.includes(c.key),
        })),
    [columns, lockedKeys]
  );

  const visibleKeys = options.filter((o) => !hidden.includes(o.key)).map((o) => o.key);

  const toggle = (key, checked) => {
    const next = checked
      ? hidden.filter((k) => k !== key)
      : [...new Set([...hidden, key])];
    onChange?.(next);
  };

  const showAll = () => onChange?.([]);

  const content = (
    <div style={{ minWidth: 220, maxHeight: "60vh", overflowY: "auto" }}>
      <Space direction="vertical" size={4} style={{ display: "flex" }}>
        {options.map((o) => (
          <Checkbox
            key={o.key}
            checked={visibleKeys.includes(o.key)}
            disabled={o.locked}
            onChange={(e) => toggle(o.key, e.target.checked)}
          >
            {o.title}
            {o.locked ? (
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {" "}
                (ซ่อนไม่ได้)
              </Typography.Text>
            ) : null}
          </Checkbox>
        ))}
      </Space>

      <Divider style={{ margin: "8px 0" }} />

      <Space>
        <Button size="small" onClick={showAll}>
          แสดงทั้งหมด
        </Button>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          ระบบจำไว้ในเครื่องนี้
        </Typography.Text>
      </Space>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement="bottomRight"
      title="เลือกคอลัมน์ที่ต้องการแสดง"
      content={content}
    >
      <Button
        size="small"
        className="bn-action bn-center justify-center"
        icon={<SettingOutlined />}
      >
        {buttonText}
        {hidden.length > 0 ? ` (ซ่อน ${hidden.length})` : ""}
      </Button>
    </Popover>
  );
}
